import gql from 'graphql-tag'

// USED IN: PATIENT_NOTES
export const GetPatientsById = gql`
  query GetPatientsById($ids: [ID!]!) {
    patients(input: { ids: $ids }) {
      results {
        id,
        person {
          firstName,
          middleName,
          lastName,
          dateOfBirth,
          gender,
          prefix,
          suffix
        },
        mrn
        emrId,
        emrIdType
        fhirId
      }
    }
}`

export const SearchAllPatients = gql`
  query SearchPatients($name: String!, $limit: Int) {
    searchPatients(input: { name: $name, limit: $limit }) {
      results {
        person {
          lastName
          firstName
          middleName
          gender
          dateOfBirth
        }
        mrn
        id
        emrId
        emrIdType
        fhirId
      }
    }
}`

export const SearchEMRPatient = gql`
  query searchEMRPatient($name: String,$mrn: String!, $emrType: EMRType!) {
    searchEMRPatient(input: {name: $name, mrn: $mrn, emrType: $emrType}) {
      patients {
        emrId
        emrIdType
        fhirId
        id
        mrn
        person {
          dateOfBirth
          firstName
          gender
          lastName
          middleName
          prefix
          suffix
        }
      }
    }
  }
`

export const CreateOrUpdatePatient = gql`
  mutation CreateOrUpdatePatient($id: ID, $person: PersonInput!, $mrn: String) {
    createOrUpdatePatient(input: {
      id: $id,
      person: $person,
      mrn: $mrn
    }) {
      patient {
        person {
          lastName
          firstName
          middleName
          gender
          dateOfBirth
        },
        id
        person {
          lastName
          firstName
          middleName
          gender
          dateOfBirth
        }
        mrn
        emrId
        emrIdType
        fhirId
      }
    }
  }
`
// PATIENT LIST
export const GetPatientList = gql`
  query GetPatientList($organizationId: ID, $userId: ID) {
    getPatientList(input: { userId: $userId, organizationId: $organizationId }) {
      patientList {
          patients {
              emrId,
              emrIdType,
              fhirId,
              id,
              mrn,
              person {
                  dateOfBirth,
                  firstName,
                  gender,
                  lastName,
                  middleName,
                  prefix,
                  suffix,
              }
          }
      }
    }
}
`

export const AddToPatientList = gql`
  mutation AddToPatientList($patient: PatientInput!, $userId: ID, $organizationId: ID) {
    addToPatientList(input: {patients: [$patient], organizationId: $organizationId, userId: $userId}) {
        success
    }
  }
`

export const RemoveFromPatientList = gql`
  mutation RemoveFromPatientList($id: String!, $userId: ID, $organizationId: ID) {
    removeFromPatientList(input: {patientIds: [$id], userId: $userId, organizationId: $organizationId}) {
        success
    }
  }
`
